import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { BaseViewSchema } from "./views";

export enum ViewExportStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}

export enum ViewExportType {
  STANDARD = "standard",
  EXPANDED = "expanded",
}

export enum ViewExportScope {
  ALL = "all",
  SELECTED = "selected",
}

const ViewExportSchema_ = z.object({
  _id: zExt.objectId(),
  view: BaseViewSchema,
  exportType: createEnum(ViewExportType, { enumName: "ViewExportType" }),
  exportScope: createEnum(ViewExportScope, { enumName: "ViewExportScope" }),
  status: createEnum(ViewExportStatus, { enumName: "ViewExportStatus" }),
  createdAt: z.date(),
  updatedAt: z.date(),
  team: zExt.objectId(),
  user: zExt.objectId(),
  fileUrl: z.string().nullish(),
  selectedDocumentIds: z.array(z.string()).nullish(),
  sendToEmail: z.email().nullish(),
  rowsProcessed: z.number().nullish(),
  totalRows: z.number().nullish(),
});

export const ViewExportSchema: z.ZodType<ViewExportSchema> = ViewExportSchema_;
export interface ViewExportSchema extends z.infer<typeof ViewExportSchema_> {}
